var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFindingAJob = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Job-Search--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Job Search Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23.64 22.29 -4.09 -4.09a0.26 0.26 0 0 1 0 -0.34c0.21 -0.26 0.4 -0.53 0.59 -0.81A1 1 0 0 0 18.45 16a9 9 0 0 1 -15 0A1 1 0 0 0 2 15.67a1 1 0 0 0 -0.29 1.38 11 11 0 0 0 16.09 2.54 0.25 0.25 0 0 1 0.33 0l4.1 4.1a1 1 0 1 0 1.41 -1.42Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.79 6.78h-1.42a0.87 0.87 0 0 0 -0.88 0.87v5.71a0.87 0.87 0 0 0 0.88 0.88h1.42a2.3 2.3 0 0 0 1.91 -3.59 0.28 0.28 0 0 1 0 -0.28 2.3 2.3 0 0 0 -1.91 -3.59Zm-0.55 2a0.25 0.25 0 0 1 0.25 -0.25h0.3a0.55 0.55 0 0 1 0.56 0.55 0.56 0.56 0 0 1 -0.56 0.55h-0.3a0.25 0.25 0 0 1 -0.25 -0.25Zm0.55 3.71h-0.3a0.25 0.25 0 0 1 -0.25 -0.25v-0.61a0.25 0.25 0 0 1 0.25 -0.25h0.3a0.56 0.56 0 1 1 0 1.11Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78 9.08v2.86a2.3 2.3 0 0 0 4.6 0V9.08a2.3 2.3 0 0 0 -4.6 0Zm2.85 0v2.86a0.55 0.55 0 0 1 -1.1 0V9.08a0.55 0.55 0 0 1 1.1 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.67 11.94V7.65a0.88 0.88 0 0 0 -1.75 0v4.29a0.56 0.56 0 0 1 -1.11 0 0.88 0.88 0 1 0 -1.75 0 2.31 2.31 0 0 0 4.61 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.21 9.08a2.3 2.3 0 0 0 2.3 2.3 0.56 0.56 0 0 1 0 1.11h-1.43a0.88 0.88 0 0 0 0 1.75h1.43a2.31 2.31 0 0 0 0 -4.61 0.55 0.55 0 0 1 -0.51 -0.55 0.54 0.54 0 0 1 0.55 -0.55h1.43a0.88 0.88 0 0 0 0 -1.75h-1.47a2.3 2.3 0 0 0 -2.3 2.3Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.44 5.65a1 1 0 0 0 1.4 -0.17 9 9 0 0 1 14.16 0 1 1 0 0 0 0.79 0.38 1 1 0 0 0 0.62 -0.21 1 1 0 0 0 0.17 -1.4 11 11 0 0 0 -17.35 0 1 1 0 0 0 0.21 1.4Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFindingAJob);
export default ForwardRef;